import { InfoTooltip } from './InfoTooltip';

export default InfoTooltip;
